import styled from "@emotion/styled";
import { Box, ListItem, ListItemButton } from "@mui/material";
import Badge from "@mui/material/Badge";
import StarIcon from "@mui/icons-material/Star";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import DraftsIcon from "@mui/icons-material/Drafts";

const alertIconSize = 28;
export const AlertListItemHeaderWrapper = styled(Box)`
  margin: 0 10px;
  font-size: 0.8em;
`;

export const AlertWrapper = styled(Box)`
  display: flex;
  flex: 1;
  overflow-y: auto;
  padding: 0;
`;

export const AlertWidgetWrapper = styled(Box)`
  height: 88%;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`;

export const PriorityAlertsListWrapper = styled("div")`
  flex: 1 1 auto;
  max-height: 50%;
  overflow-y: auto;
`;

export const AlertTabBadge = styled(Badge)`
  margin: 6px 0;
`;

export const PriorityIcon = styled(WarningRoundedIcon)`
  width: ${alertIconSize}px;
`;

export const AcknowledgementIcon = styled(ThumbUpIcon)`
  width: ${alertIconSize}px;
`;

export const ReferralIcon = styled(DraftsIcon)`
  width: ${alertIconSize}px;
`;

export const StarredMessageIcon = styled(StarIcon)`
  width: ${alertIconSize}px;
`;

export const AlertMessageTypeListItemWrapper = styled(ListItem)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

export const AlertMessageTypeListItemButton = styled(ListItemButton)`
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  padding: 10px 0 0 0;
`;
